module.exports = __webpack_public_path__ + "img/checked.2ebea310.png";